import cssVars from '@figma/fpl-tokens/css-vars';
import { ColorTheme, ThemeProvider as FplThemeProvider } from '@figma/fpl-themes';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { CircularProgress } from '@/UI/CircularProgress/CircularProgress';
import { FlexCenHorVer } from '@/UI/styles';
import { color } from '@/colors';
import { ZIndex } from '@/consts/z-indexes.consts';
import { FplMigrationProvider, useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import { readStoredThemeMode, resolveThemePreference } from '@/utils/themeMode.utils';
import { useSystemThemeMode } from '@/hooks/useSystemThemeMode';

export function PageLoader() {
  const isFplMigrationEnabled = useFplMigrationFlag();

  return (
    <FlexCenHorVer
      data-testid="page-loader"
      sx={{
        zIndex: ZIndex.Overlays.LOADING_OVERLAY,
        background: isFplMigrationEnabled ? cssVars.color.bg : color.Black100,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      <CircularProgress color="inherit" sx={{ color: token.text }} fplProps={{ size: 'lg' }} />
    </FlexCenHorVer>
  );
}

/** Full-page loader for surfaces that mount before `WeaveThemeProvider` (auth bootstrap). */
export function StandalonePageLoader() {
  // This renders outside `ThemeModeProvider` — and outside the Router that `useFeatureFlag` needs —
  // so the mode comes straight from the storage mirror rather than context. The mirror is cleared
  // whenever the flag resolves off (see `ThemeModeContext`), which is what keeps this dark during a
  // flagged-off rollout. Falls back to dark when nothing is stored.
  const systemMode = useSystemThemeMode();
  const mode = resolveThemePreference(readStoredThemeMode(), systemMode);

  return (
    <FplMigrationProvider>
      <FplThemeProvider>
        <ColorTheme brand="weave" mode={mode}>
          <FlexCenHorVer className="App" sx={{ width: '100vw', height: '100vh', position: 'relative' }}>
            <PageLoader />
          </FlexCenHorVer>
        </ColorTheme>
      </FplThemeProvider>
    </FplMigrationProvider>
  );
}
